import {getAuthUser} from "@/helpers/Helpers";
import { Pagination } from "@/interfaces/general";
import { ServerErrorResponse, ServerErrorSuccessResponse, ServerExceptionData } from "@/interfaces/serverResponse";
import { AppConstants } from "@/webComponents/wcOrderDetail/constants";

export default {
    computed: {
        role_name(): string {
            return this.auth_user && this.auth_user.role.name ? this.auth_user.role.name.toLowerCase() : ''
        }
    },
    data() {
        return {
            auth_user: getAuthUser(),
            custom_product_path_info:  {
                name: "Custom Design",
                url: "placeholders/custom-design.png",
                extension: "svg",
            }
        }
    },
    methods: {
        showToast(message: string, title: string): void{
            this.$toast.open({
                message: message, 
                title: title,
                type: title === 'SUCCESS' ? 'success' : 'error',
                dismissible: true,
                duration: 5000,
                position: 'bottom-left'
            });
        },
        logout(): void{
            localStorage.removeItem('access_token');
            localStorage.removeItem('user');
            this.$router.push('login');
            this.showToast("Your session expired, please login again", 'DANGER');
        },
        showServerErrors(response): void {
            const toaster_errors = response.data.errors;
            if(toaster_errors.length == 0) {
                toaster_errors.push(response.data.message);
            }
            toaster_errors.forEach(error_message => {
                this.$toast.open({
                    message: error_message,
                    title: 'DANGER',
                    type: 'error',
                    dismissible: true,
                    duration: 5000,
                    position: 'bottom-left'
                });
            })
        },
        showError(err): void{
            console.log("errors", err);
            const errors = err.response.data.errors;
            const errArr = [];
            Object.keys(errors).map((field) => {
                errArr.push(errors[field][0]);
            });
            errArr.forEach(element => {
                this.$toast.open({
                    message: element, 
                    title: 'DANGER',
                    type: 'error',
                    dismissible: true,
                    duration: 5000,
                    position: 'bottom-left'
                });
            })
        },
        makePagination(data: Pagination): void{
            this.pagination.currentPage = data.current_page;
            this.pagination.rows = data.total;
            this.pagination.perPage = data.per_page;
            this.pagination.total = data.total;
        },
        handleResponseErrors(errorResponse: TypeError | ServerErrorResponse | Error) {
            let errors = [];
            if("isAxiosError" in errorResponse) {
              const response = errorResponse.response as unknown as ServerErrorResponse;
              const responseData = response.data as ServerExceptionData | ServerErrorSuccessResponse;
              if(responseData.message) {
                errors.push(responseData.message);
              }
              if("errors" in responseData) {
                errors = [...errors, ...responseData.errors];
              }
            } else {
                errors.push(errorResponse.message);
            }
            if ( AppConstants.isOrderDetailWebComponent === false) {
              if(errors && errors.length > 0) {
                errors.forEach(error => this.showToast(error, 'DANGER'))
            }
          }
        }
    }
}